import { Component, OnInit, OnDestroy, ViewChild, ElementRef } from "@angular/core";
import { ProfileService } from "src/app/services/profile/profile.service";
import { SpinnerService } from "src/app/services/spinner/spinner.service";
import { AlertService } from "src/app/services/alert/alert.service";
import { AuthService } from "src/app/services/auth/auth.service";
import { Location } from "@angular/common";
import { FormBuilder } from "@angular/forms";
import { Platform, ActionSheetController, ModalController } from "@ionic/angular";
import { TranslateService } from "@ngx-translate/core";
import { Camera } from "@ionic-native/camera/ngx";
import * as moment from "moment";
import { Profile } from "src/app/models/profile";
import { DurcService } from "src/app/services/durc/durc.service";
import { UploadDurcDocument } from '../../models/durc'

@Component({
  selector: 'app-durc',
  templateUrl: './durc.page.html',
  styleUrls: ['./durc.page.scss'],
})
export class DurcPage implements OnInit {

  @ViewChild("inputFileDurc", { static: false }) inputFileDurc: ElementRef;

  profile: Profile;

  durc: UploadDurcDocument = {
    buffer: '',
    computedFileName: '',
    uploadedFileName: '',
    mimeType: ''
  };

  durcFolder: any[] = [];

  protected readonly dateFormat: string = 'DD/MMMM/YYYY';
  protected readonly regexPattern: any = /\.[^\/.]+$/;

  constructor(
    private profileService: ProfileService,
    private spinner: SpinnerService,
    private alert: AlertService,
    private auth: AuthService,
    private location: Location,
    private platform: Platform,
    private translate: TranslateService,
    private actionSheet: ActionSheetController,
    private camera: Camera,
    private modalController: ModalController,
    private durcService: DurcService,
    protected fb: FormBuilder,
  ) {
  }

  async ngOnInit() {
    this.getProfile();
  
    this.getDurcDocumentFolder();
  }

  async getProfile() {
    this.profile = await this.profileService.getProfile();
    this.createFileName();
  }

  createFileName() {
    const { firstName = "", lastName = "" } = this.profile; 
    this.durc.computedFileName = `DURC_${firstName}_${lastName}_${moment().format(this.dateFormat)}`;
  }

  showDurcDocumentStatement() {
    return this.durcFolder && this.durcFolder.length > 0;
  }

  getLastDurcDocument() {
    return this.durcFolder[this.durcFolder.length - 1];
  }

  async chooseFile() {
    if (!this.platform.is("cordova")) {;
      this.inputFileDurc.nativeElement.click();
      return;
    }
    try {
      const texts = await this.translate
        .get(["UPLOAD_DOCUMENT", "GALLERY", "CLOSE", "CAMERA", "PDF_DOCUMENT"])
        .toPromise();

      const sheet = await this.actionSheet.create({
        mode: "md",
        header: texts.UPLOAD_DOCUMENT,
        buttons: [
          {
            text: texts.PDF_DOCUMENT,
            icon: "document",
            handler: async () => this.inputFileDurc.nativeElement.click(),
          },
          {
            text: texts.CLOSE,
            role: "cancel",
            icon: "close",
          },
        ],
      });

      await sheet.present();
    } catch (err) {
      console.log(err);
    }
  }

  async inputFileChange(event) {
    const [file = null] = event.target.files || [];
    
    if (file) {
      this.durc.buffer = await this.getBase64(event.target.files[0]);
      this.durc.uploadedFileName = file.name; 
      // TIP file.name.replace(this.regexPattern, '');
      // TIP this.durc.uploadedFileExtension = file.name.split(".").pop().toLowerCase();
      const fileExtension = file.name.split(".").pop().toLowerCase();
      this.durc.computedFileName = `${this.durc.computedFileName}.${fileExtension}`
      this.durc.mimeType = file.type;
    }
  }

  getBase64(file): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result as string);
      reader.onerror = (error) => reject(error);
    });
  }
  
  async confirm() {
    await this.alert.confirm({
      titleKey: 'DURC_ALERT_TITLE',
      messageKey: 'DURC_ALERT_MESSAGE',
      okTextKey: 'CONFIRM',
      cancelTextKey: 'CLOSE',
      cancelHandler: async () => await this.modalController.dismiss(),
      okHandler: async () => await this.save()
    });
  }

  async save() {
    try {
      await this.spinner.show();

      // TIP extract from file the real base64 encoding
      const splitFile = this.durc.buffer.split(',');
      splitFile.shift();
      this.durc.buffer = splitFile.join('');

      const token = await this.auth.getToken();
      await this.durcService.sendDurcDocument(token, this.durc);

      await this.spinner.dismiss();
      this.location.back();
    } catch (err) {
      this.durc.buffer = '';
      await this.spinner.dismissWithAlertError(err);
    }
  }

  async getDurcDocumentFolder() {
    const token = await this.auth.getToken();
    const body = await this.durcService.getDurcFolder(token);
    this.durcFolder = body;
  }

}